const categories = {
    label: 'Category',
    slug: 'category',
    values: [
        'Breakfast',
        'Cocktails',
        'Crockpot',
        'Desserts',
        'Entrees',
        'Holiday',
        'Salads',
        'Sauces, Dressings, & Seasonings',
        'Shakeology',
        'Sides & Snacks',
        'Soups',
    ],
};

const containers = {
    label: 'Container',
    slug: 'container',
    values: [
        'Blue',
        'Green',
        'Orange',
        'Purple',
        'Red',
        'Yellow',
        'Teaspoon',
        'Free',
    ],
};

const dietary = {
    label: 'Dietary',
    slug: 'dietary',
    values: [
        'Gluten-Free',
        'Gut Protocol',
        'High in Fiber',
        'High in Protein',
        'Non-Dairy',
        'Quick & Easy',
        'Paleo',
        'Vegan',
        'Vegetarian',
        '80 Day',
    ],
};

const source = {
    label: 'Source',
    slug: 'source',
    values: [
        'Blog',
        'Cooking Show',
        'Cookbook Vol 1',
        'Cookbook Vol 2',
        'DietBet',
        'LWLC Book',
        'Monthly Group',
        'Monthly Group (New)',
        'Gut Protocol',
    ],
};

export default { categories, containers, dietary, source };
